import { Modal, Button } from '@indipia/ui-core'
// 상세창 저장 안 한 변경 이탈 확인 · 당기기 확인 다이얼로그(후행공정 함께 이동 여부)

export type GanttConfirmModalsProps = {
  leavePrompt: { run: () => void; } | null
  setLeavePrompt: React.Dispatch<React.SetStateAction<{ run: () => void; } | null>>
  pullConfirm: { taskId: number; taskName: string; newStart: Date; newEnd: Date; direction: "pull" | "push"; } | null
  setPullConfirm: React.Dispatch<React.SetStateAction<{ taskId: number; taskName: string; newStart: Date; newEnd: Date; direction: "pull" | "push"; } | null>>
  resolvePullConfirm: (mode: "self" | "cascade") => void
}

export function GanttConfirmModals({
  leavePrompt, setLeavePrompt, pullConfirm, setPullConfirm, resolvePullConfirm,
}: GanttConfirmModalsProps) {
  return (
    <>
      <Modal
        open={leavePrompt != null}
        onClose={() => setLeavePrompt(null)}
        title="저장하지 않은 변경이 있어요"
        footerAlign="stretch"
        footer={<>
          <Button variant="secondary" onClick={() => setLeavePrompt(null)}>계속 편집</Button>
          <Button variant="danger" onClick={() => { const run = leavePrompt?.run; setLeavePrompt(null); run?.() }}>저장 안 하고 이동</Button>
        </>}
      >
        <div style={{ fontSize: 12, color: 'var(--shell-on-surface-2)', lineHeight: 1.6 }}>
          공종 상세창에서 수정한 내용이 아직 저장되지 않았어요.
        </div>
      </Modal>

      {/* ── 당기기 확인 다이얼로그(후행공정 함께 이동 여부) ─────────── */}
      <Modal
        open={pullConfirm != null}
        onClose={() => setPullConfirm(null)}
        title="후행공정도 함께 이동할까요?"
        footerAlign="stretch"
        footer={pullConfirm && (
          <>
            <Button variant="secondary" onClick={() => resolvePullConfirm('self')}>이 공종만 이동</Button>
            <Button variant="primary" onClick={() => resolvePullConfirm('cascade')}>후행공종도 함께 이동</Button>
          </>
        )}
      >
        {pullConfirm && (
          <>
            <div style={{ fontSize: 12, color: 'var(--shell-on-surface-2)', lineHeight: 1.6 }}>
              {pullConfirm.direction === 'pull'
                ? <>{pullConfirm.taskName}의 시작일을 앞으로 당겼습니다. 후행공정도 함께 앞당길까요, 아니면 이 공종만 이동할까요?</>
                : <>{pullConfirm.taskName}의 시작일을 뒤로 미뤘습니다. 후행공정도 함께 미룰까요, 아니면 이 공종만 이동할까요?</>}
            </div>
          </>
        )}
      </Modal>
    </>
  )
}
